import { useApi } from './useApi';
import { useAppState } from './useAppState';
import { getHttpInstance, getApiConfig } from './useApi';
export function useCustomer() {
    const api = useApi();
    const state = useAppState();
    function getCustomer(onSuccess = null, useCache = true) {
        if (!state.customer || !useCache) {
            api.GET("/Customers/00000000-0000-0000-0000-000000000000?getFacts=false", (result) => {
                state.customer = result;
                if (onSuccess)
                    onSuccess();
            }, useCache);
        }
        else {
            if (onSuccess)
                onSuccess();
        }
    }
    function updateCustomerDetails(updateRequest, onSuccess = null) {
        getHttpInstance().post(getApiConfig().api + "/Customers/00000000-0000-0000-0000-000000000000/UpdateRequests", updateRequest)
            .then((response) => {
            if (onSuccess)
                onSuccess(response.data);
        })
            .catch((result) => {
            if (result.response && result.response.status == 401) {
                api.refreshLogin(() => updateCustomerDetails(updateRequest, onSuccess));
            }
        });
    }
    function clearCustomer() {
        const config = getApiConfig();
        const prefix = config.api + (config.useCachedEndpoints ? '/Cached' : '');
        localStorage.removeItem(prefix + '/Customers/00000000-0000-0000-0000-000000000000?getFacts=false');
        localStorage.removeItem(prefix + '/Customers/00000000-0000-0000-0000-000000000000?getFacts=true');
    }
    function registerCustomer(customer, password, accessToken, onSuccess = null) {
        const url = getApiConfig().api + '/Customers?createUser=true&password=' + encodeURIComponent(password) + '&verifyEmail=true' + (accessToken != null ? '&licenseToken=' + encodeURIComponent(accessToken) : '');
        getHttpInstance().post(url, customer)
            .then((response) => {
            if (onSuccess)
                onSuccess(response.data);
        })
            .catch((result) => {
            console.log(result, 'ERROR CAUGHT');
        });
    }
    function verifyEmail(email, code, onSuccess = null) {
        getHttpInstance().post(getApiConfig().api + '/AccountConfirmations', { email, code })
            .then((response) => {
            if (onSuccess)
                onSuccess(response.data);
        })
            .catch((result) => {
            console.log(result, 'ERROR CAUGHT');
        });
    }
    function verifyToken(token, onSuccess = null) {
        getHttpInstance().get(getApiConfig().api + "/Licenses/" + token)
            .then((result) => {
            if (onSuccess)
                onSuccess(result.data);
        })
            .catch(() => {
            if (onSuccess)
                onSuccess(null);
        });
    }
    function savePreferences(onSuccess = null) {
        getHttpInstance().post(getApiConfig().api + "/Customers/00000000-0000-0000-0000-000000000000/Preferences", state.customer.preferences)
            .then((result) => {
            state.customer = result.data;
            clearCustomer();
            if (onSuccess)
                onSuccess();
        })
            .catch((result) => {
            if (result.response && result.response.status == 401) {
                api.refreshLogin(() => savePreferences(onSuccess));
            }
        });
    }
    function getEmployer(employerId, onSuccess = null) {
        if (!state.employer) {
            api.GET("/Employers/" + employerId, (result) => {
                state.employer = result;
                if (onSuccess)
                    onSuccess();
            }, true);
        }
        else {
            if (onSuccess)
                onSuccess();
        }
    }
    function getEmployerLogo(employerId, onSuccess = null) {
        api.GET("/Employers/" + employerId + '/logo', (result) => {
            if (onSuccess)
                onSuccess(result);
        }, true);
    }
    function validateEmployer(email, onSuccess = null) {
        getHttpInstance().post(getApiConfig().api + "/EmployerValidationRequests", { email })
            .then((response) => {
            if (onSuccess)
                onSuccess(response.data);
        });
    }
    function emailIsVerified(verificationId, onSuccess = null) {
        api.GET("/VerifiedEmails/" + verificationId, (result) => {
            if (result && onSuccess)
                onSuccess();
        });
    }
    function getCustomerTags(onSuccess = null) {
        api.GET("/Customers/00000000-0000-0000-0000-000000000000/CustomerTags", (result) => {
            state.customerTags = result;
            if (onSuccess)
                onSuccess(result);
        }, true);
    }
    function getTransactionsForCustomerTag(tagId, onSuccess = null) {
        api.GET("/Customers/00000000-0000-0000-0000-000000000000/CustomerTags/" + tagId + "/Transactions", (result) => {
            if (onSuccess)
                onSuccess(result);
        }, true);
    }
    function deleteCustomerTag(tagId, onSuccess = null) {
        getHttpInstance().delete(getApiConfig().api + "/Customers/00000000-0000-0000-0000-000000000000/CustomerTags/" + tagId)
            .then((response) => { if (onSuccess)
            onSuccess(response.data); })
            .catch((result) => {
            if (result.response && result.response.status == 401) {
                api.refreshLogin(() => deleteCustomerTag(tagId, onSuccess));
            }
        });
    }
    function clearCustomerTagsCache() {
        for (let i = 0; i < localStorage.length; i++) {
            const key = localStorage.key(i);
            if (key && key.includes('/CustomerTags')) {
                localStorage.removeItem(key);
                i--;
            }
        }
    }
    function lookupAddress(postCode, houseNumber, onSuccess = null) {
        const http = getHttpInstance();
        const headers = http.defaults.headers.common;
        http.defaults.headers.common = { "Authorization": "c8f9f85f-2d53-46ba-a2b3-8cef87c7ab93" };
        http.post(getApiConfig().api + "/Addresses/AddressLookupRequests", { postCode, house: houseNumber })
            .then((response) => {
            http.defaults.headers.common = headers;
            if (onSuccess)
                onSuccess(response.data);
        })
            .catch(() => {
            http.defaults.headers.common = headers;
            if (onSuccess)
                onSuccess({ addresses: [], success: true, count: 0 });
        });
        http.defaults.headers.common = headers;
    }
    return {
        getCustomer,
        updateCustomerDetails,
        clearCustomer,
        registerCustomer,
        verifyEmail,
        verifyToken,
        savePreferences,
        getEmployer,
        getEmployerLogo,
        validateEmployer,
        emailIsVerified,
        getCustomerTags,
        getTransactionsForCustomerTag,
        deleteCustomerTag,
        clearCustomerTagsCache,
        lookupAddress,
    };
}
